import { getColors } from '../config/keypointConfig'

// Keypoint colors loaded from YAML configuration
export const KEYPOINT_COLORS = getColors()
